import 'photoswipe/dist/photoswipe.css'
import React, { useEffect, useState } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import { Gallery, Item } from 'react-photoswipe-gallery'

import styles from './styles.module.scss'

import { getWorkSessionGallery } from '../../api'

import Grownu from '../../components/Icons/Grownu'

const LogbookGallery = () => {
  const { hash: workHash } = useParams()
  const location = useLocation()

  const [photos, setPhotos] = useState([])
  
  useEffect(() => {
    getWorkSessionGallery(`${workHash}${location.search}`).then(res => {
      if (Array.isArray(res)) {
        const images = res.map(i => `${i.url}`)
        setPhotos(images)
      }
    })
  }, [workHash])

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Grownu />
        <div className={styles.title}>Images</div>
      </div>
      <div className={`${styles.gallery} ${photos.length > 2 ? styles.galleryThree : styles.galleryFew}`}>
        <Gallery withDownloadButton>
          {
            photos.map((url, i) => {
              return (
                <Item
                  key={i}
                  original={url}
                  thumbnail={url}
                >
                  {({ ref, open }) => {
                    return (
                      <div className={styles.imageContainer}>
                        <img ref={ref} src={url} alt='comment' className={styles.image} onClick={open} />
                      </div>
                    )
                  }}
                </Item>
              )
            })
          }
        </Gallery>
      </div>
    </div>
  )
}

export default LogbookGallery
